import { Fragment, useEffect, useState } from 'react'
import Head from 'next/head'



import Header from '../components/Header/Header'
import Text from '../components/Text/Text'
import ImageBlock from '../components/ImageBlock/ImageBlock'
import LinkCard from '../components/LinkCard/LinkCard'
import CardList from '../components/CardList/CardList'
import PeopleCard from '../components/PeopleCard/PeopleCard'
import LoadMore from '../components/LoadMore/LoadMore'
import Footer from '../components/Footer/Footer'
import Seo from '../components/Seo/Seo'

// Fetch data variables
let apiUrl = process.env.API_URL
const queryPeople = require('../queries/gqlPeople.graphql')
const initialTeamLimit = 12

const People = (props) => {
  const { metadata, page, partners, team, teamTotal } = props

  const [teamLimit, setTeamLimit] = useState(initialTeamLimit)
  const [teamCards, setTeamCards] = useState(team)

  useEffect(() => {
    document.querySelector('body').classList.add('is-generic')
    return () => {
      document.querySelector('body').classList.remove('is-generic')
    }
  }, [])

  useEffect(() => {
    if(teamLimit !== initialTeamLimit) {
      fetchPeople()
    }
  }, [teamLimit])

  const fetchPeople = async () => {
    const queryData = {
      variables: { teamLimit: teamLimit },
      query: queryPeople
    }

    const opts = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(queryData)
    }

    const res = await fetch(apiUrl, opts)
    const json = await res.json()
    console.log("People", json);
    setTeamCards(json.data.team)
  }

  return (
    <Fragment>
      <Seo {...metadata}/>

      <Header {...page.header[0]} alignment={page.header[0].imageAlignment}/>

      {props.page.components.map((component, index) => {
        switch (component.type) {
          case 'text':
            return (
              <Text key={`${component.type}-${index}`} {...component} />
            )
          case 'image':
            return (
              <ImageBlock {...component} key={`${component.type}-${component.id}`}/>
            )
        }
      })}

      {partners &&
      <CardList key={`CardList-partners`} heading={`Partners`} type={`people`}>
        {partners.map((person, index) => {
          return <PeopleCard {...person} key={`PeopleCard-${person.id}-${index}`}/>
        })}
      </CardList>
      }

      {teamCards &&
        <>
          <CardList key={`CardList-team`} heading={`Team`} type={`people`} >
            {teamCards.map((person, index) => {
              return <PeopleCard {...person} key={`PeopleCard-${person.id}-${index}`}/>
            })}
          </CardList>
          { teamTotal > teamLimit &&
           <LoadMore onClick={() => { setTeamLimit(teamLimit + 5) }} modifier={`LoadMore--people is-left`} label="More people"/>
          }
        </>
      }


      {page.referral &&
      <CardList layout={`stacked`} type="themes" key={`CardList-${page.referral[0].id}`}>
        <LinkCard {...page.referral[0]} />
      </CardList>
      }

      <Footer />

    </Fragment>
  )
}

export async function getServerSideProps (context) {
  const queryData = {
    variables: { teamLimit: initialTeamLimit },
    query: queryPeople
  }

  const opts = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(queryData)
  }

  // update api url to enable live and share preview
  if (context.query) {
    if (context.query.token && !!(context.query['x-craft-live-preview'] || context.query['x-craft-preview'])) {
      apiUrl = `${process.env.API_URL}?token=${context.query['token']}`
    }
  }

  const res = await fetch(apiUrl, opts)
  const json = await res.json()
  // console.log(apiUrl, opts);
  return {
    props: {
      page: json.data.page,
      partners: json.data.partners,
      team: json.data.team,
      teamTotal: json.data.teamTotal.length,
      metadata: {
        ...JSON.parse(json.data.metadata.metaTitleContainer).title,
        ...JSON.parse(json.data.metadata.metaTagContainer)
      }
    }
  }
}

export default People
